export const TEXT_SCALES = [
  { value: '0.9', label: 'S', desc: 'Kompakt' },
  { value: '1', label: 'M', desc: 'Standard' },
  { value: '1.1', label: 'L', desc: 'Größer' },
  { value: '1.25', label: 'XL', desc: 'Sehr groß' },
];

const KEY = 'app-text-scale';

export const getTextScale = () => {
  try { return localStorage.getItem(KEY) || '1'; } catch { return '1'; }
};

export const applyTextScale = (v) => {
  const scale = v || getTextScale();
  try { localStorage.setItem(KEY, scale); } catch { /* ignore */ }
  document.documentElement.style.zoom = scale === '1' ? '' : scale;
};
